import { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { orderService } from '../services/orderService';
import Loading from '../components/common/Loading';
import './KhaltiCallback.css';

const KhaltiCallback = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [status, setStatus] = useState('verifying'); // verifying | success | failed | canceled
    const [message, setMessage] = useState('Verifying your payment...');
    const [order, setOrder] = useState(null);

    useEffect(() => {
        const pidx = searchParams.get('pidx');
        const khaltiStatus = searchParams.get('status');

        if (!pidx) {
            setStatus('failed');
            setMessage('Invalid payment callback. No payment identifier found.');
            return;
        }

        // If Khalti already says canceled, show immediately
        if (khaltiStatus === 'User canceled') {
            setStatus('canceled');
            setMessage('You cancelled the payment. Your order is still saved — you can retry payment later.');
            return;
        }

        // Verify the payment with our backend
        const verifyPayment = async () => {
            try {
                const result = await orderService.verifyKhaltiPayment(pidx);

                if (result.success) {
                    setStatus('success');
                    setMessage('Payment successful! Your order has been confirmed.');
                    setOrder(result.data?.order);
                } else {
                    const khaltiResultStatus = result.data?.khalti_status;
                    if (khaltiResultStatus === 'User canceled') {
                        setStatus('canceled');
                        setMessage('You cancelled the payment. Your order is still saved.');
                    } else if (khaltiResultStatus === 'Expired') {
                        setStatus('failed');
                        setMessage('Payment session expired. Please try again.');
                    } else {
                        setStatus('failed');
                        setMessage(result.message || 'Payment verification failed.');
                    }
                }
            } catch (error) {
                setStatus('failed');
                setMessage(error.message || 'Failed to verify payment. Please contact support.');
            }
        };

        verifyPayment();
    }, [searchParams]);

    const handleGoToOrders = () => {
        navigate('/profile?orderSuccess=true');
    };

    const handleGoHome = () => {
        navigate('/');
    };

    if (status === 'verifying') {
        return (
            <div className="khalti-callback-page">
                <div className="khalti-callback-card">
                    <div className="khalti-loading">
                        <Loading />
                        <p>{message}</p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="khalti-callback-page">
            <div className="khalti-callback-card">
                <div className={`khalti-status-icon ${status}`}>
                    {status === 'success' && '✓'}
                    {status === 'failed' && '✕'}
                    {status === 'canceled' && '↩'}
                </div>

                <h2 className={`khalti-status-title ${status}`}>
                    {status === 'success' && 'Payment Successful'}
                    {status === 'failed' && 'Payment Failed'}
                    {status === 'canceled' && 'Payment Cancelled'}
                </h2>

                <p className="khalti-status-message">{message}</p>

                {order && (
                    <div className="khalti-order-info">
                        <p>Order: <strong>#{order.order_number}</strong></p>
                        <p>Total: <strong>Rs. {parseFloat(order.total).toLocaleString()}</strong></p>
                    </div>
                )}

                <div className="khalti-callback-actions">
                    {status === 'success' && (
                        <button className="btn-primary" onClick={handleGoToOrders}>
                            View My Orders
                        </button>
                    )}
                    {(status === 'failed' || status === 'canceled') && (
                        <>
                            <button className="btn-primary" onClick={handleGoToOrders}>
                                View My Orders
                            </button>
                            <button className="btn-secondary" onClick={handleGoHome}>
                                Go Home
                            </button>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default KhaltiCallback;
